import React from 'react'
import {  Row, Col, Spinner } from 'react-bootstrap'

const SpinnerContainer = ({ label, size }) => {
    return (
        <React.Fragment>
            <Row>
                <Col className='text-center'>
                    <Spinner animation="border" role="status" size={size}>
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </Col>
            </Row>
            {label &&
            <Row>
                <Col className='text-center'>
                    {label}
                </Col>
            </Row>
            }
        </React.Fragment>
    )
}

export default SpinnerContainer